import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const PlayerLanguageModalTrackContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  height: auto;
  left: ${72 * Screen.widthRatio}px;
  position: relative;
  top: ${196 * Screen.widthRatio}px;
  width: ${234 * Screen.widthRatio}px;
`;

export default PlayerLanguageModalTrackContainer;
